import {DialogActions, IconButton, Stack, SxProps, Theme, useMediaQuery, useTheme} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { FC, ReactNode } from 'react'
import CloseCircleIcon from '../../assets/icons/CloseCircle.svg?react'
import {theme} from "../../theme";

interface Props {
    open: boolean
    title: ReactNode
    headerActions?: ReactNode
    footerActions?: ReactNode
    descriptionFooterActions?: ReactNode
    handleClose: () => void
    children: ReactNode
    sx?: SxProps<Theme>
}

export const ModalDialogWrapper: FC<Props> = ({
    open,
    handleClose,
    title,
    headerActions,
    footerActions,
    descriptionFooterActions,
    children,
    sx,
}) => {
    const { breakpoints } = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    return (
        <Dialog
            disableRestoreFocus
            open={open}
            onClose={handleClose}
            sx={{
                '.MuiPaper-root': {
                    width: '560px',
                },
                [breakpoints.down('sm')]: {
                    '.MuiDialog-container': {
                        alignItems: 'flex-end',
                    },
                    '.MuiPaper-root': {
                        m: 0,
                        borderRadius: '28px 28px 0 0',
                    },
                },
                ...sx,
            }}>
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    m: 0,
                    p: 2.5,
                    pr: 2,
                    pl: 3,
                }}>
                {title}
                <Stack direction="row" alignItems="center" gap={1}>
                    {headerActions}
                    <IconButton onClick={handleClose} size="large" sx={{ p: 0 }}>
                        <CloseCircleIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>

            <DialogContent sx={{ textAlign: 'left', p: 3 }}>{children}</DialogContent>

            {footerActions && (
                <>
                    <DialogActions
                        sx={{
                            p: descriptionFooterActions ? 1 : 3,
                            pt: 1,
                            [breakpoints.down('sm')]: {
                                p: 2,
                                pt: 2,
                            },
                        }}>
                        {footerActions}
                    </DialogActions>
                    {descriptionFooterActions && (
                        <Stack
                            direction="row"
                            justifyContent="center"
                            sx={{ p: isMobile ? '0px 16px 16px  ' :'16px 24px 32px 24px', '>p': { color: '#707274' } }}>
                            {descriptionFooterActions}
                        </Stack>
                    )}
                </>
            )}
        </Dialog>
    )
}
